import React from 'react';
import { HelpCircle, LogOut } from 'lucide-react';
import { FaBars } from 'react-icons/fa';
import './Header.css';
import { logout } from '../../auth/logoutUser';

const Header = ({ user, onLogout, toggleSidebar }) => {

  return (
    <header className="header">
      <div className="left-section">
        {/* Hamburger button toggles sidebar visibility */}
        <button
          className="icon-btn hamburger-btn"
          onClick={toggleSidebar}
          aria-label="Toggle sidebar"
          title="Toggle sidebar"
        >
          <FaBars />
        </button>

        {/* Logo image */}
        <img src="/argus-logo.png" alt="Logo" className="logo-img" />

        {/* App title and subtitle */}
        <div className="title-section">
          <h1 className="app-title">ARGUS</h1>
          <h5 className="app-subtitle">Analytical Review & Guidance for Unresolved Services</h5>
        </div>
      </div>

      <div className="right-section">
        {/* Notification, Messages, Help, and Settings icons */}
        <a
          className="icon-btn"
          href="https://marsvethealth.sharepoint.com/sites/BluePearlBusinessAnalysis/SitePages/ARGUS-Resources.aspx"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Help"
          title="Help"
        >
          <HelpCircle size={20} />
        </a>

        {/* Display user info if user is logged in */}
        {user && (
          <div className="user-info">
            {/* Welcome message with user's display name */}
            <span className="welcome-text">Welcome, {user.givenName}!</span>

            {/* User avatar with fallback image on error */}
            <img
              src={user.photo}
              alt="User avatar"
              className="user-avatar"
              onError={(e) => { e.target.src = '/default-avatar.jpg'; }}
            />

            {/* Logout button triggers onLogout callback */}
            <button
              onClick={logout}
              className="icon-btn logout-btn"
              aria-label="Logout"
              title="Logout"
            >
              <LogOut size={20} />
            </button>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;